/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import { NavLink, useParams } from "react-router-dom";

import Footer from "../../../../components/common/Footer";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";

import { propertyCardData } from "../../../../data/guestcards";
import { content, html } from "../../../../data/vacancies";

import JSZip from "jszip";
import { saveAs } from "file-saver";
import { RiDownload2Fill } from "react-icons/ri";

import { Col, Row } from "antd";
import TextArea from "antd/es/input/TextArea";

import "./PostVacancyManually.css";

const PostVacancyManuallyRightBar = [];

function PostVacancyManually() {
  const [property, setProperty] = useState({});
  const [imagePreview, setImagePreview] = useState(false);
  const [htmlPreview, setHTMLPreview] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    const newObject = propertyCardData.find((item) => {
      return item.id == id;
    });
    setProperty(newObject);
    console.log(newObject);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [property]);
  // console.log(property)

  function handleDownloadClick(images) {
    const zip = new JSZip();

    images.forEach((image, index) => {
      const fileName = `image-${index}.jpeg`;
      zip.file(fileName, image, { binary: true });
    });

    zip.generateAsync({ type: "blob" }).then((content) => {
      saveAs(content, "images.zip");
    });
  }

  return (
    <>
        <div className="post-vacancy-manually">
          <PageHeading heading="Post Vacancy Manually" />

          <div className="post-vacancy-manually">
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <Row gutter={[0, 16]}>
                  <Col span={24}>
                    <p>
                      Follow the instructions below to manually post this unit
                      to any online listing service.{" "}
                      <span className="onclick-text">Learn More</span>
                    </p>
                  </Col>
                  <Col span={24}>
                    <Row gutter={[16, 0]}>
                      <Col span={4}>
                        <img
                          src={property?.media ? property.media[0] : null}
                          alt=""
                        />
                      </Col>
                      <Col span={20}>
                        <Row gutter={[0, 10]}>
                          <Col span={24}>
                            <p className="onclick-text">
                              {property?.propertyName}
                            </p>
                          </Col>
                          <Col span={24}>
                            <hr />
                          </Col>
                          <Col span={24}>
                            <p>{property?.address} </p>
                            <p>
                              <strong>Beds: </strong> {property?.bedRooms}{" "}
                              <strong>Baths:</strong> {property?.bathRooms}{" "}
                              <strong>Sq. Ft.:</strong> {property?.squareFeet}{" "}
                            </p>
                          </Col>
                          <Col span={24}>
                            <hr />
                          </Col>
                          <Col span={24}>
                            <p>
                              <strong>Market Rent:</strong> ${property?.rent}{" "}
                            </p>
                            <p>
                              <strong>Available:</strong> {property?.availabel}
                            </p>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={24}>
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <p className="border-bottom">1. Download Images</p>
                  </Col>
                  <Col span={24}>
                    <p>
                      Click on the "download images" button to download a ZIP
                      file that contains all the images for this unit. This
                      download will also include an automatically generated
                      marketing image.
                    </p>
                  </Col>
                  <Col span={24}>
                    <button
                      className="icon-btn"
                      onClick={() => handleDownloadClick(property?.media)}
                    >
                      <RiDownload2Fill size={18} /> <span>Download Images</span>
                    </button>
                  </Col>
                  <Col span={24}>
                    <div
                      className="no-line"
                      onClick={() => setImagePreview(!imagePreview)}
                    >
                      <span>{`[+]`} </span>
                      <p className="onclick-text">Preview Marketing Image</p>
                    </div>
                  </Col>
                  {imagePreview ? (
                    <Col span={12} className="preview-container">
                      <img
                        className="preview-image"
                        src={property?.media ? property.media[0] : null}
                        alt=""
                      />
                      <Row
                        justify="end"
                        gutter={[24, 0]}
                        className="info-container"
                      >
                        <Col className="border-left">
                          <strong>{property?.bedRooms}</strong>
                          <p className="silver-text">BEDS</p>
                        </Col>
                        <Col className="border-left">
                          <strong>{property?.bathRooms}</strong>
                          <p className="silver-text">BATHS</p>
                        </Col>
                        <Col className="border-left">
                          <strong>{property?.rent}</strong>
                          <p className="silver-text">RENT / MONTH</p>
                        </Col>
                      </Row>
                    </Col>
                  ) : null}
                </Row>
              </Col>
              <Col span={24}>
                <Row gutter={[0, 8]}>
                  <Col span={24}>
                    <p className="border-bottom">
                      2. Copy and Paste Listing Detail HTML
                    </p>
                  </Col>
                  <Col span={24}>
                    <p>
                      We've generated the following HTML code which will display
                      the details of your unit in a simple, easy to read format.
                      Simply copy and paste this code in the description field
                      of the Internet Listing Service.
                    </p>
                  </Col>
                  <Col span={24}>
                    <TextArea rows={8} defaultValue={content} />
                  </Col>
                  <Col span={24}>
                    <div
                      className="no-line"
                      onClick={() => setHTMLPreview(!htmlPreview)}
                    >
                      <span>{`[+]`} </span>
                      <p className="onclick-text">Preview HTML Description</p>
                    </div>
                  </Col>
                  {htmlPreview ? (
                    <Col span={24}>
                      <div className="html-container">
                        <pre>{html}</pre>
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </Col>
            </Row>
          </div>
          <Footer />
        </div>
      <div className="RightSidebar">
        <RightBar RightBarData={PostVacancyManuallyRightBar} />
      </div>
    </>
  );
}

export default PostVacancyManually;
